// extracted by mini-css-extract-plugin
module.exports = {"textGray":"Product_textGray__24tcw","back":"Product_back__3Reu3","backLink":"Product_backLink__1feMM","backLinkText":"Product_backLinkText__2MraC"};